<template>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 tile-destination">
    <div class="x_panel">
      <div class="x_title">
        <h2>Destination</h2>
        <ul
          class="nav navbar-right panel_toolbox"
          v-if="item.status !== 'Shipped' &&
        (checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE))">
          <li>
            <div
              class="btn-group"
              role="group"
              aria-label="...">
              <button
                type="button"
                @click="changeDestinationDialogVisible = true"
                class="btn btn-default po-tile-edit-button">
                <i
                  class="fa"
                  :class="[ hasCustomerAddress ? 'fa-exchange' : 'fa-plus']"
                  aria-hidden="true"></i> {{ hasCustomerAddress ? 'Change' : 'Add' }}
              </button>
              <button
                v-if="hasCustomerAddress"
                type="button"
                class="btn btn-default"
                @click="showEditDestinationDialog">
                <i class="fa fa-edit"></i> Edit
              </button>
            </div>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div
        class="x_content destinationCardLoading"
        v-if="hasCustomerAddress">
        <el-row>
          <p><strong>Name:</strong></p>
          <p> <span>{{ item.customerAddress.name !== '' ? item.customerAddress.name : item.customerAddress.customer.name }} </span></p>
          <p><strong>Address:</strong></p>
          <p v-if="item.customerAddress.street">
            {{ item.customerAddress.street }} , {{ item.customerAddress.suburb }}
            <br>
            <span v-if="item.customerAddress.city">
              {{ item.customerAddress.city }} , {{ item.customerAddress.state }}
            </span>
            <br>
            <span v-if="item.customerAddress.country">
              {{ item.customerAddress.postcode }} - {{ item.customerAddress.country }}
            </span>
          </p>
          <p v-else>
            <em >No address in this destination
              <span
                v-if="(checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE)) &&
              item.status !== 'Shipped'">
                - Click in 'Edit' to add
              </span>
            </em>
          </p>
        </el-row>
        <el-dialog
          :title="editDestinationTitle"
          :visible.sync="editDestinationDialogVisible">
          <el-form
            :model="destinationForm"
            class="edit-destination-form"
            label-position="top"
            :rules="destinationFormRules"
            label-width="100px"
            ref="destinationForm">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="Street"
                  prop="street">
                  <el-input
                    v-model="destinationForm.street"
                    :placeholder="item.customerAddress.street ?
                  item.customerAddress.street : 'No street recorded'">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Suburb"
                  prop="suburb">
                  <el-input
                    v-model="destinationForm.suburb"
                    :placeholder="item.customerAddress.suburb ?
                  item.customerAddress.suburb : 'No suburb recorded'">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="City"
                  prop="city">
                  <el-input
                    v-model="destinationForm.city"
                    :placeholder="item.customerAddress.city ?
                  item.customerAddress.city : 'No city recorded'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="State"
                  prop="state">
                  <el-input
                    v-model="destinationForm.state"
                    :placeholder="item.customerAddress.state ?
                  item.customerAddress.state : 'No state recorded'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="Postcode"
                  prop="postcode">
                  <el-input
                    v-model="destinationForm.postcode"
                    :placeholder="item.customerAddress.postcode ?
                  item.customerAddress.postcode : 'No postcode recorded'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Country"
                  prop="country">
                  <el-input
                    v-model="destinationForm.country"
                    :placeholder="item.customerAddress.country ?
                  item.customerAddress.country : 'No country recorded'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="Phone number"
                  prop="phone">
                  <el-input
                    v-model="destinationForm.phone"
                    :placeholder="item.customerAddress.phone ?
                  item.customerAddress.phone : 'No phone recorded'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Mobile number"
                  prop="mobile">
                  <el-input
                    v-model="destinationForm.mobile"
                    :placeholder="item.customerAddress.mobile ?
                  item.customerAddress.mobile : 'No mobile phone recorded'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="Email"
                  prop="email">
                  <el-input
                    v-model="destinationForm.email"
                    :placeholder="item.customerAddress.email ?
                  item.customerAddress.email : 'No email recorded'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span
            slot="footer"
            class="dialog-footer">
            <el-button @click="editDestinationDialogVisible = false">Cancel</el-button>
            <el-button
              type="success"
              @click="submitEditDestination">Save</el-button>
          </span>
        </el-dialog>
      </div>
      <div
        class="x_content"
        v-else>
        <div class="tile-stats">
          <div class="row">
            <h3 class="text-center empty-title">No destination defined.</h3>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Select a new destination or create a new one"
      :visible.sync="changeDestinationDialogVisible"
      @close="onClose">
      <el-row ref="destinationForm">
        <p>Search for a saved <strong>destination</strong> below or create a new one:</p>
        <el-row>
          <el-select
            v-if="!showInputDestination"
            class="select-destination"
            v-model="destQuery"
            clearable
            filterable
            placeholder="Select a saved destination. Create a new one below."
            @change="handleSelect"
            no-data-text="No saved destinations">
            <el-option
              v-for="item in getCustomersAddresses"
              :key="item[0].id"
              :label="item[0].name !== '' ? item[0].name : item[0].customer.name"
              :value="item[0].id">
            </el-option>
          </el-select>
          <p
            class="show-input-name"
            @click="showInputDestination = true"
            v-if="!showInputDestination">Click here to add a new destination</p>
          <el-input
            placeholder="Add a name for the new destination"
            v-model="destinationName"
            v-if="showInputDestination"></el-input>
          <p
            class="show-input-name"
            @click="showInputDestination = false"
            v-if="showInputDestination">Go back to selection</p>
        </el-row>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="changeDestinationDialogVisible = false">Cancel</el-button>
        <el-button
          type="success"
          :loading="isLoading"
          @click="submitDestination">Change destination</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as groups from '@/js/user-groups';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    updates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      customerAddressUpdates: [],
      isDestSelected: false,
      isLoading: false,
      destinationName: '',
      addNewDestination: false,
      destQuery: '',
      changeDestinationDialogVisible: false,
      showInputDestination: false,
      addDestFormVisible: false,
      selectedDestinationId: null,
      editDestinationDialogVisible: false,
      destinationForm: {
        street: '',
        suburb: '',
        city: '',
        state: '',
        postcode: '',
        country: '',
        phone: '',
        mobile: '',
        email: '',
      },
      destinationFormRules: {
        name: [
          { required: true, message: 'Please input a name', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getCustomers: 'getCustomers',
      getUser: 'getUser',
    }),
    getGroups() {
      return groups;
    },
    getCustomersAddresses() {
      const destinations = this.getCustomers
        .filter(a => a.customerAddresses.length > 0)
        .map(a => a.customerAddresses);
      return destinations;
    },
    editDestinationTitle() {
      return `Edit ${this.item.customerAddress.name}'s infos below:`;
    },
    hasCustomerAddress() {
      return this.item.customerAddress;
    },
  },
  created() {
    for (let i = 0; i < this.updates.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(this.updates[i], 'customerAddress')) {
        this.customerAddressUpdates.push(this.updates[i]);
      }
    }
  },
  mounted() {
    this.$store.dispatch('setCustomers');
    this.setDestinationFormValue();
  },
  methods: {
    checkUserGroup(group) {
      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()) {
            return true;
          }
        }
      }
      return true;
    },
    showEditDestinationDialog() {
      this.setDestinationFormValue();
      this.editDestinationDialogVisible = true;
    },
    checkCustomerAddressValue(key) {
      if (typeof this.item.customerAddress === null) {
        return this.item.customerAddress[key] !== '';
      }
      return false;
    },
    setDestinationFormValue() {
      Object.keys(this.destinationForm).map((key) => {
        if (this.checkCustomerAddressValue(key)) {
          this.destinationForm[key] = this.item.customerAddress[key];
          return true;
        }
        this.destinationForm[key] = '';
        return false;
      });
    },
    openCreateDialog() {
      this.dialogFormVisible = true;
      this.$store.dispatch('getCustomers');
    },
    onClose() {
      this.addDestFormVisible = false;
    },
    destQuerySearch(queryString, cb) {
      const customers = this.getCustomers;
      customers.forEach(obj => this.savedDestinations.push(obj.customerAddresses));
      const results = queryString ? customers.filter(this.createFilter(queryString)) : customers;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return customer => customer.value.indexOf(queryString) === 0;
    },
    submitUpload() {
      if (this.$refs.upload.$children[0].fileList[0]) {
        this.isUploading = true;
        this.$refs.upload.submit();
      }
      return this.$message.warning('You need to select a file');
    },
    handleSelect(item) {
      this.selectedDestinationId = item;
      this.isDestSelected = true;
    },
    submitDestination() {
      this.isLoading = true;
      if (this.selectedDestinationId) {
        const destinationObj = { poId: this.item.id, destinationId: this.selectedDestinationId };
        this.$store.dispatch('updateCustomerAddress', destinationObj);
        this.changeDestinationDialogVisible = false;
        this.isLoading = false;
        this.destinationName = '';
      } else if (this.destinationName !== '') {
        const destinationObj = { poId: this.item.id, destinationName: this.destinationName };
        this.$store.dispatch('createCustomerAddress', destinationObj);
        this.changeDestinationDialogVisible = false;
        this.isLoading = false;
        this.destinationName = '';
      } else {
        this.$message({
          message: 'Select a destination or create a new one!',
          type: 'warning',
        });
        this.isLoading = false;
      }
    },
    submitEditDestination() {
      const destinationObj = { poId: this.item.id };
      Object.keys(this.destinationForm).map((key) => {
        if (this.destinationForm[key] !== '') {
          const keyName = key;
          destinationObj[keyName] = this.destinationForm[key];
        }
        return this.destinationForm[key];
      });
      this.$store.dispatch('updateCustomerAddress', destinationObj);
      this.editDestinationDialogVisible = false;
      this.setDestinationFormValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-form-item {
  margin-bottom: 15px;
}
.el-select{
  width: 100%;
}

.el-upload,.el-autocomplete,.el-select {
  width: 100%;
}
.el-form-item__label {
  font-weight: 300;
}
button {
  margin: 0;
}
.el-select.select-destination {
  padding-left: 0;
}
.show-input-name {
  cursor: pointer;
  text-decoration: underline;
  margin: 15px 0;
  &:hover {
    text-decoration: none;
  }
}
.empty-title {
  margin: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoDestination.vue